// import ClazzStandardApi from '../../../api/src/course_standard/api/ClazzStandardApi'
import DictApi from '../../../api/src/basic/api/DictApi'
import {arrToTree} from '../../../utils/index'

// const clazzStandardApi = new ClazzStandardApi()
const dictApi = new DictApi();

const state = {
    courseList: [],
    randomIds: [],
    courseDetail: []
}

const mutations = {
    addCourseList(state, data) {
        state.courseList = data
    },
    addRandomIds(state, data = []){
        state.randomIds = data
    },
}

const actions = {

    editKnowledgeMap: async function ({commit, state},courseStandardId) {
        let data = await clazzStandardApi.editKnowledgeMap(courseStandardId);
        let treeData = arrToTree(data.knowledgeMap,'id', 'pid')
        commit('addCourseList',treeData)
    },

    getRandomId: ({commit, state})=>{
        dictApi.getRandomId().then(res=>{
            commit('addRandomIds',res)
        })
    },


}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}
